module.exports = __webpack_public_path__ + "static/media/checkbox.216b26d5.svg";